import { render, staticRenderFns } from "./DragTable.vue?vue&type=template&id=d6bf0210&scoped=true&"
import script from "./DragTable.vue?vue&type=script&lang=js&"
export * from "./DragTable.vue?vue&type=script&lang=js&"
import style0 from "./DragTable.vue?vue&type=style&index=0&id=d6bf0210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bf0210",
  null
  
)

export default component.exports